import type { IconType } from 'react-icons';
import {
    TbArchive,
    TbArchiveOff,
    TbBookmark,
    TbBookmarkOff,
    TbClipboard,
    TbClipboardOff,
    TbCircleCheck,
} from 'react-icons/tb';

/** Icons for order actions (bulk bar, order detail menu). Not used for status dots. */
export const ORDER_ACTION_ICONS = {
    archive: TbArchive,
    unarchive: TbArchiveOff,
    flag: TbBookmark,
    unflag: TbBookmarkOff,
    markReviewed: TbClipboard,
    removeReview: TbClipboardOff,
    complete: TbCircleCheck,
} satisfies Record<string, IconType>;
